<template>
    <div class="work-box">
            <p>智能建造资源升级，加入我们实现转型新方式</p>
            <p>获取合作方案，共享仿真资源</p>
            <div class="input-find-box">
                <el-input v-model="nameValue" placeholder="请输入您的姓名"></el-input>
                <el-input v-model="phoneValue" placeholder="请输入您的手机号"></el-input>
                <div>联系我们</div>
            </div>
        </div>
</template>

<script>
    export default {
        data(){
            return {
                 /**绑定姓名 */
                 nameValue:'',
                /**绑定手机号 */
                phoneValue:'',
            }
        }
    }
</script>

<style lang="less" scoped>
.work-box{
    height: 32rem;
    background-image: url(../../assets/image/course/work-bg.png);
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    &> :nth-child(1){
        font-size: 3.6rem;
        color: #151C34;
        font-weight: 700;
    }
    &> :nth-child(2){
        color: #151C34;
        font-size: 16px;
        margin: 3rem 0 4.7rem 0;
    }
    &> :nth-child(3){
        display: flex;
        align-items: center;
        &> :nth-child(2){
            margin-left: 1.8rem;
        }
        &> :nth-child(3){
            margin-left: 3.2rem;
            padding: 0 3rem;
            height: 4.2rem;
            border-radius: 5px;
            background-color: #5085FB;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
        }
    }
    /deep/.el-input__inner{
        box-shadow: 0px 0px 10px 0px rgba(124,130,141,0.15); 
        width: 30rem;
        height: 4.2rem;
    }
}
@media screen and (max-width:750px){
    .work-box{
        white-space: normal;
        padding: 4rem var(--padding);
        height: auto;
        &> :nth-child(1){
            font-size: 17px;
        }
    }
    .input-find-box{
        width: 100%;
        flex-direction: column;
        padding: 0 3rem;
        row-gap: 1rem;
        &> :nth-child(2){
            margin-left: 0 !important;
        }
        &> :nth-child(3){
            margin-left: 0 !important;
            width: 100% !important;
            border-radius: 2rem !important;
        }
        /deep/.el-input__inner{
        width: 100% !important;
        border-radius: 2rem;
    }
    }
}
</style>